import { buildOrthancUrl } from '../config/pacsConfig'
import { buildPacsBasicAuth } from './pacs/pacsAuth'

/**
 * Envía un archivo DICOM al PACS via POST /instances (Orthanc REST API).
 *
 * @param {Uint8Array} bytes  - Bytes DICOM Part 10 (GSPS o SR).
 * @param {Object|null} pacsConfig - Entrada de PACS_CONFIG. Si es null/undefined
 *   no hay PACS configurado y la función devuelve false sin intentar el POST.
 * @returns {Promise<boolean>} true si el PACS respondió 200 o 409 (ya existe),
 *   false si no hay PACS o falló (el caller debe hacer fallback a saveAs).
 */
export async function storeDicomInstanceToPacs(bytes, pacsConfig) {
  if (!pacsConfig || !pacsConfig.IP) {
    return false
  }

  const baseUrl = buildOrthancUrl(pacsConfig).replace(/\/$/, '')
  const url = `${baseUrl}/instances`

  const auth = buildPacsBasicAuth(pacsConfig)

  let response
  try {
    response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/dicom',
        ...(auth ? { Authorization: auth } : {}),
      },
      body: bytes,
    })
  } catch (networkError) {
    console.warn('[storeDicomInstanceToPacs] Error de red:', networkError)
    return false
  }

  // 200 = almacenado, 409 = ya existía (idempotente) → ambos cuentan como éxito.
  if (response.status === 200 || response.status === 409) {
    return true
  }

  console.warn(
    `[storeDicomInstanceToPacs] Respuesta inesperada del PACS: ${response.status}`
  )
  return false
}
